module.exports = __webpack_public_path__ + "static/media/green.5d82e67c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/portfolio/green.png
// module id = 327
// module chunks = 0